import React, { useEffect, useState } from 'react';
import { View, Platform, TouchableOpacity, Image, ActivityIndicator } from 'react-native';
import EStyleSheet from 'react-native-extended-stylesheet';
import Modal from '../../services/modal';
import Paragraph from '../Content/Paragraph';
import { modalReadStyles as styles } from './styles';
import API from '../../config/api';
import ImageSecured from '../../containers/ImageSecured';
import { Ionicons } from '@expo/vector-icons';

function ModalRead({
	text, imageId, isVisible, onHide, imageUrl, s3Url
}) {
	console.log(imageUrl, imageId, "imageUrl");
	const [loading, setLoading] = useState(true);
	const [onError, setOnError] = useState(false);
	const [uri, setUri] = useState("");

	useEffect(() => {
		console.log(imageId, "imageId");

		if (imageId.includes("data")) {
			setUri(`https://sb-all-images-data.s3.ca-central-1.amazonaws.com/${imageId}`)
		}
		else {
			setUri(`https://sb-all-images-data.s3.ca-central-1.amazonaws.com/${API() !== "https://biz.safebuildingsapp.ca" ? 'dev-' : ''}patrol-data/${imageId}`)
		}
	}, [])
	return (
		<Modal
			backdropColor={EStyleSheet.value('$white')}
			backdropOpacity={0.75}
			isVisible={isVisible}
			onBackdropPress={onHide}
			onBackButtonPress={onHide}
			animationIn="zoomIn"
			animationOut="zoomOut"
			onSwipeComplete={onHide}
			useNativeDriver
			swipeDirection={['down', 'left', 'up', 'right']}
		>
			<View style={[styles.modalContainer, Platform.OS === 'web' && { margin: "30%" }]}>
				<TouchableOpacity onPress={onHide} style={[styles.roundControl, { alignSelf: "flex-end", margin: 10 }]}>
					<View style={styles.bubbleClose}>
						<Ionicons style={styles.iconClose} name="md-close" />
					</View>
				</TouchableOpacity>
				{isVisible &&
					<View style={styles.modalImageContainer}>
						{loading && <ActivityIndicator size={"large"} />}
						{onError && <View style={styles.modalContent}>
							<Paragraph center>
								⏳ Image is uploading, please check back shortly.
							</Paragraph>
						</View>}
						{imageUrl ?
							<>
								<Image
									style={[styles.modalImage]}
									resizeMode={"contain"}
									source={{ uri: `${imageUrl}` }}
									onLoad={() => { setLoading(false); }}
									onError={() => { setOnError(true); setLoading(false) }}
								/>
							</>
							:
							<Image
								style={[styles.modalImage]}
								resizeMode="contain"
								id={imageId}
								source={{ uri: uri }}
								onLoad={() => { setLoading(false); }}
								onError={() => { setOnError(true); setLoading(false) }}
							/>
						}
					</View>
				}
				{text && (
					<View style={styles.modalContent}>
						<Paragraph>
							{text}
						</Paragraph>
					</View>
				)}
			</View>
		</Modal>
	);
}

export default ModalRead;
